import { Injectable,   } from '@angular/core';
import { tap } from 'rxjs';
import { BaseService } from './base.service';

import { TranslateService as NgxTranslateService } from '@ngx-translate/core';
import { LocalStorage } from '../helpers/localstorage.helper';

@Injectable({
  providedIn: 'root'
})
export class TranslationService extends BaseService {
  currentLang: 'ar' | 'en' = 'ar';
  private _Localization = {};

  constructor( private ngxTranslateService: NgxTranslateService) {
    super()
  }

  loadLocalization() {
    return this.http.get(`${this.absoluteHostNameURL}AppData/LocalizationDictionary.json`).pipe(tap((res: any) => {
      this._Localization = { ar: JSON.parse(res.ar), en: JSON.parse(res.en) };
      this.ngxTranslateService.addLangs(['en', 'ar']);
      this.ngxTranslateService.setDefaultLang('ar');
      const browserLang: any = this.ngxTranslateService.getBrowserLang();
      this.ngxTranslateService.use('ar')//(browserLang.match(/en|ar/) ? browserLang : 'en');
      this.ngxTranslateService.store.translations = this.localization;
      this.ngxTranslateService['changeDefaultLang']()
      return res;
    }))
  }

  setLang(val : any) {
    const value = val || 'ar';
    this.ngxTranslateService.use(value);
    LocalStorage.set('lang', value)
    document.documentElement.setAttribute('lang', value);
    this.currentLang = value;
  }
  switchLang() {
    if (this.currentLang == 'ar') {
      this.setLang('en')
      LocalStorage.set('LanguagePrefrences', 'en-SA')
    } else {
      this.setLang('ar')
      LocalStorage.set('LanguagePrefrences', 'ar-SA')
    }
  }
  public get localization(): any {
    return this._Localization;
  }

}
